import { FC } from 'react'
import { Driver, DriverDocumentFile } from '../../../../types'
import { useSingleEntity } from 'modules/domain/common/hooks'
import { endpoints } from 'modules/endpoints'
import { DocumentType } from 'modules/domain/types'
import { apiClient } from 'modules/utils/httpClient'
import { FilesByTypesModal } from './FilesByTypesModal'
import { useTranslation } from 'react-i18next'

type Props = {
  driver?: Driver
  driverId: number
  setDocumentsCounter?: (arg) => void
  withDriverName?: boolean
  maxWidth?: number
  readOnly?: boolean
}

export const DriverDocuments: FC<Props> = ({ driverId, maxWidth, readOnly }) => {
  const [, types = []] = useSingleEntity<DocumentType[]>(endpoints.LogisticsKR.driverDocumentTypes(driverId))
  const [, documents, documentsRefetch] = useSingleEntity<DriverDocumentFile[]>(
    endpoints.LogisticsKR.driverDocuments(driverId),
  )
  const { t } = useTranslation('logisticsKR')
  const descriptions = {
    knd_1151162_form: t('carriers.accordion.descriptions.knd_1151162_form'),
    copy_report_efs1: t('carriers.accordion.descriptions.copy_report_efs1'),
  }

  const onDeleteHandler = async (document_id) => {
    try {
      await apiClient.delete(endpoints.LogisticsKR.driverDocument(driverId, document_id))
      documentsRefetch()
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <div style={maxWidth ? { maxWidth } : undefined}>
      <FilesByTypesModal
        types={types}
        files={documents || []}
        refetch={documentsRefetch}
        onDelete={onDeleteHandler}
        uploadUrl={endpoints.LogisticsKR.driverUploadDocuments(driverId)}
        description={descriptions}
        readOnly={readOnly}
      />
    </div>
  )
}
